module.exports = __webpack_public_path__ + "static/media/DomenicForte.07a471ec.jpeg";